import { Dayjs } from 'dayjs';

import { SDate } from '@summit/core';

import { DateRangeType } from './date-range-type.enum';
import { Week } from './week';
const debugging: boolean = false;

export class DateRange {
  begin!: Dayjs;
  end!: Dayjs;
  //*noUnusedParameters private offset?: number;
  newWeekType?: DateRangeType | 'ReportWeek' | 'PriorMonth' | 'PriorWeek' | 'PayrollWeek' | 'IVMRWeek';

  constructor(jsonData?: Partial<DateRange> | DateRangeType, dateRangeType?: DateRangeType) {
    //console.log(`DateRange constructor called with,`, jsonData, dateRangeType);
    //if ((jsonData as any)?.['newWeekType'] === DateRangeType.ScheduleWeek) this.debugging = true;
    if (jsonData) {
      if (DateRange.isDateRange(jsonData) && jsonData.begin) {
        this.begin = SDate.newUtc(jsonData.begin);
      } else if ((jsonData as any).start) {
        this.begin = SDate.newUtc((jsonData as any).start);
      }
      if (DateRange.isDateRange(jsonData) && jsonData.end) {
        this.end = SDate.newUtc(jsonData.end);
      } else if (this.begin) {
        this.end = SDate.GetEndOfWeekUtc(this.begin);
      }
      if (((jsonData as any).offset || (jsonData as any).offset == 0) && !this.begin && !this.end) {
        const selWeek = new Week((jsonData as any).offset, dateRangeType);
        this.begin = selWeek.start;
        this.end = selWeek.end;
      }
      if (!this.begin && !this.end) {
        //console.log(`No dates found, setting to new week based on `, jsonData, dateRangeType);
        const selType = DateRange.isDateRange(jsonData)
          ? jsonData.newWeekType
            ? jsonData.newWeekType
            : DateRangeType.TenantWeek
          : jsonData;
        if (debugging) console.log(`Setting to type: ${selType}`);
        // Preconfigured ones
        switch (selType) {
          case DateRangeType.ReportWeek:
          case DateRangeType.ReportWeek.toString():
          case 'ReportWeek':
            if (debugging)
              console.log(
                `Calling setToReportWeek with ${dateRangeType} and current time: ${SDate.getNormalized().format()}`
              );
            this.setToReportWeek(dateRangeType);
            break;
          case DateRangeType.IVMRWeek:
          case DateRangeType.IVMRWeek.toString():
          case 'IVMRWeek':
            if (debugging) console.log(`Calling setToIVMRWeek`);
            this.setToIVMRWeek(dateRangeType);
            break;
          case DateRangeType.ScheduleWeek:
          case DateRangeType.ScheduleWeek.toString():
            if (debugging) console.log(`Calling setToScheduleWeek`);
            this.setToScheduleWeek(dateRangeType);
            break;
          case DateRangeType.PayrollWeek:
          case 'PayrollWeek':
            if (debugging) console.log(`Calling setToPayrollWeek`);
            this.setToPayrollWeek(dateRangeType);
            break;
          case DateRangeType.PriorWeek:
          case 'PriorWeek': {
            if (debugging) console.log(`Calling setToPriorWeek`);
            let selWeek = new Week();
            selWeek = selWeek.ChangeOffsetBy(-1);
            this.begin = selWeek.start;
            this.end = selWeek.end;
            break;
          }
          case DateRangeType.PriorMonth:
          case 'PriorMonth': {
            if (debugging) console.log(`Calling set to prior month`);
            const today = SDate.getNormalized();
            const monthAgo = today.subtract(1, 'month');
            this.begin = monthAgo.startOf('month').startOf('day');
            this.end = monthAgo.endOf('month').startOf('day');
            break;
          }
          default:
            break;
        }
      }
    }
    if (!this.begin && !this.end) {
      //if (debugging) { console.log(`Const from new week`); }
      const selWeek = new Week();
      this.begin = selWeek.start;
      this.end = selWeek.end;
    }
    // Ensure both begin and end are always set
    if (!this.begin && this.end) {
      this.begin = SDate.GetStartOfWeekUtc(this.end);
    }
    if (this.begin && !this.end) {
      this.end = SDate.GetEndOfWeekUtc(this.begin);
    }
    if (debugging) console.log(`Returning type: ${dateRangeType} as ${JSON.stringify(this)}`);
  }

  setToDates(): void {
    this.begin = this.begin.startOf('day');
    this.end = this.end.startOf('day');
  }

  setToReportWeek(dateRangeType?: DateRangeType): DateRange {
    //if (debugging) { console.log(`Report week of ${DateRangeTypeMapping[dateRangeType]}`); }
    let selWeek = new Week();
    let weekCutOff = selWeek.GetFedExCutOff();
    // console.log(`Report Week: Comparing ${SDate.newUtc().format()} to ${weekCutOff.format()}`);
    while (SDate.newUtc().isBefore(weekCutOff)) {
      // console.log(
      //   `[Report Week] looking at date range ${selWeek.fedExStart.format()}-${selWeek.fedExEnd.format()} for ${dateRangeType}`
      // );
      selWeek = selWeek.ChangeOffsetBy(-1);
      weekCutOff = selWeek.GetFedExCutOff();
    }
    if (dateRangeType === DateRangeType.SettlementWeek) {
      // console.log(
      //   `[Report Week] Returning Settlement based on ${selWeek.fedExStart.format()}-${selWeek.fedExEnd.format()} for ${dateRangeType}`
      // );
      this.begin = selWeek.fedExStart;
      this.end = selWeek.fedExEnd;
    } else {
      // console.log(
      //   `[Report Week] Returning Tenant based on ${selWeek.start.format()}-${selWeek.end.format()} for ${dateRangeType}`
      // );
      this.begin = selWeek.start;
      this.end = selWeek.end;
    }
    // console.log(
    //   `[Report Week] Created date range ${this.begin.format('MM/DD/YY')}-${this.end.format('MM/DD/YY')} for ${dateRangeType}`
    // );
    return this;
  }
  setToPayrollWeek(dateRangeType?: DateRangeType): DateRange {
    let selWeek = new Week();
    const priorWeek = selWeek.GetPriorWeek();
    const priorWeekCutOff = priorWeek.GetFedExCutOff();
    //console.log(`Comparing ${SDate.newUtc().format()} to Current week: ${selWeek.start.format()}-${selWeek.end.format()} with cut prior cut off of ${priorWeekCutOff.format()}`)
    if (SDate.newUtc().isBefore(priorWeekCutOff)) {
      //console.log(`${SDate.newUtc().format()} is before cut off (${priorWeekCutOff.format()}), moving back a week`)
      selWeek = selWeek.ChangeOffsetBy(-1);
    }
    if (dateRangeType === DateRangeType.SettlementWeek) {
      this.begin = selWeek.fedExStart;
      this.end = selWeek.fedExEnd;
    } else {
      this.begin = selWeek.start;
      this.end = selWeek.end;
    }
    // console.log(`Payroll Week: `, this);
    return this;
  }

  setToScheduleWeek(_dateRangeType?: DateRangeType): DateRange {
    const selWeek = new Week(SDate.getNormalized(), DateRangeType.ScheduleWeek);
    if (debugging) console.log(`Base Week ${selWeek.start.format()}-${selWeek.end.format()}`);
    if (debugging) console.log(`Schedule Week ${selWeek.scheduleStart.format()}-${selWeek.scheduleEnd.format()}`);
    this.begin = selWeek.scheduleStart;
    this.end = selWeek.scheduleEnd;
    return this;
  }

  setToIVMRWeek(_dateRangeType?: DateRangeType): DateRange {
    //console.log(`IVMR week of ${DateRangeTypeMapping[_dateRangeType ?? 0]}`);
    let selWeek = new Week();
    let weekCutOff = selWeek.fedExEnd;
    // console.log(`Starting with end of ivmr week ${selWeek.ivmrEnd.format()}`);
    //console.log(`Comparing ${SDate.getNormalized().format()} to ${weekCutOff.toISOString()}`);
    while (SDate.getNormalized().isBefore(weekCutOff)) {
      selWeek = selWeek.ChangeOffsetBy(-1);
      weekCutOff = selWeek.fedExEnd;
    }
    this.begin = SDate.GetStartOfDay(selWeek.ivmrStart);
    this.end = SDate.GetStartOfDay(selWeek.ivmrEnd);
    // console.log(`Created IVMR date range ${this.begin.format()}-${this.end.format()} ${selWeek.endOfIvmrWeek}`);
    return this;
  }

  toShortString(): string {
    return `${this.begin.format('MM/DD/YY')}-${this.end ? this.end.format('MM/DD/YY') : this.begin.format('MM/DD/YY')}`;
  }

  getNewEventDate(): Dayjs {
    const normalizedDate = SDate.getNormalized();
    if (this.begin.isAfter(normalizedDate)) {
      return this.begin;
    }
    if (this.end.isBefore(normalizedDate)) {
      return this.end;
    }
    return normalizedDate;
  }

  covers(date: Dayjs): boolean {
    return this.begin.isSameOrBefore(date) && this.end.isSameOrAfter(date);
  }

  sort(): DateRange {
    if (this.begin.isAfter(this.end)) {
      const temp = this.begin;
      this.begin = this.end;
      this.end = temp;
    }
    return this;
  }

  static isDateRange(x: unknown): x is DateRange {
    return (
      (x as DateRange).begin !== undefined ||
      (x as DateRange).end !== undefined ||
      (x as DateRange).newWeekType !== undefined
    );
  }
}
